export const documentCategoriesBackend = Object.freeze({
  AGENDA: 'Dagsorden',
  PLANOFACTION: 'Handleplan',
  SETINGTOPPR: 'Indstilling',
  FORCABLESCHEDULE: 'Magtanvendelsesskema',
  COMMUNICATION_BOOK: 'Meddelelsesbog',
  OBSERVATION: 'Observation',
  EDUCATIONALNOTE: 'Pædagogisk note',
  SUMMARY: 'Referat',
  SCRATCHSCHEME: 'Rive/kradseskema',
  OPENTEMPLATE: 'Åben skabelon',
  SECURE_NOTE: 'Note',
});
